<button *ngIf="preview" type="button" class="remove-button" mat-icon-button button color="warn"
        (click)="setPreview(null)">
  <mat-icon>close</mat-icon>
</button>

<label class="image-button-wrapper">
  <button type="button" class="drop-container" mat-button ngFileDrop
          (mouseover)="onDisplayUploadImageTitle()"
          (mouseleave)="onHideUploadImageTitle()"
          (uploadOutput)="onUploadOutput($event)"
          (click)="onImageSelect(fileInput)"
          [uploadInput]="uploadInput"
          [ngClass]="{ 'is-drop-over': dragOver, 'preview': preview }">

    <input #fileInput type="file" accept="image/*"
           ngFileSelect
           (uploadOutput)="onUploadOutput($event)"
           [uploadInput]="uploadInput" [style.display]="'none'">

    <div *ngIf="!preview && !process" class="titles">
      <span class="upload-title" *ngIf="!dragOver">{{ title }}</span>
      <span class="upload-title-drag" *ngIf="dragOver">{{ 'upload.file-upload.upload-title-drag' | translate }}</span>
      <mat-error *ngIf="error">{{ error | translate }}</mat-error>
    </div>

    <div class="file-info" *ngFor="let file of files" [class.complete]="file.progress.status == 2">
      <ng-container *ngIf="process">
        <span class="file-name">{{ file.name }}</span>
        <span>{{ file.progress.data.speedHuman }}</span>
        <mat-progress-bar *ngIf="file.progress.data"
                          class="example-margin"
                          [color]="'primary'"
                          [mode]="'buffer'"
                          [value]="file.progress.data.percentage">
        </mat-progress-bar>
      </ng-container>
    </div>

    <img *ngIf="preview" src="{{ preview }}" alt="Preview" class="image-preview">

    <div class="update-image" *ngIf="preview && isHoverOnPreviewImage">
      <span>{{ hoverOnPreviewText }}</span>
    </div>
  </button>


</label>
